import Konva from "konva";
import { Group, Path } from "react-konva";
import { FileColumn } from "../../controller";
import { downloadFile } from "frontend/utils/url-utils";
import Hoverable from "frontend/ui-components/konva-helpers/hoverable";

const SIZE = 24;
const ICON_WIDTH = 14;
const ICON_HEIGHT = 13;

interface DownloadButtonProps extends Konva.NodeConfig {
  file: FileColumn["value"][0];
}

export function DownloadButton(props: DownloadButtonProps) {
  const { file, ...restProps } = props;

  const icon = (
    <Group x={SIZE / 2 - ICON_WIDTH / 2} y={SIZE / 2 - ICON_HEIGHT / 2} listening={false}>
      <Path
        data="M1 8.35403L1 10.0624C1 11.0469 1.7981 11.845 2.78261 11.845L11.6957 11.845C12.6802 11.845 13.4783 11.0469 13.4783 10.0624L13.4783 8.35403"
        stroke="#7F869B"
        strokeWidth={1}
        lineCap="round"
      />
      <Path data="M7.23907 1L7.23907 8.27899" stroke="#7F869B" strokeWidth={1} lineCap="round" lineJoin="round" />
      <Path data="M5.15936 6.19897L7.23907 8.27868" stroke="#7F869B" strokeWidth={1} lineCap="round" lineJoin="round" />
      <Path data="M9.31848 6.19897L7.23877 8.27868" stroke="#7F869B" strokeWidth={1} lineCap="round" lineJoin="round" />
    </Group>
  );

  return (
    <Group
      {...restProps}
      width={SIZE}
      height={SIZE}
      onClick={(e) => {
        e.evt.stopPropagation();
        e.evt.preventDefault();
        downloadFile(file.url, file.name);
      }}
    >
      <Hoverable
        cornerRadius={6}
        width={SIZE}
        height={SIZE}
        opacity={1}
        fill="transparent"
        hoverFill="#F6F7FB"
        cursor="pointer"
        listening
      />
      {icon}
    </Group>
  );
}
